import { render, staticRenderFns } from "./AppointmentEventHandler.vue?vue&type=template&id=275ec990&scoped=true&"
import script from "./AppointmentEventHandler.vue?vue&type=script&lang=js&"
export * from "./AppointmentEventHandler.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentEventHandler.vue?vue&type=style&index=0&id=275ec990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ec990",
  null
  
)

export default component.exports